import PropTypes from "prop-types";
import { useState } from "react";
import Wizard from "../../../../../core/ui/components/Wizard";

import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";

const ModalTutorial = ({ modalState }) => {
    async function onNextTab() {
        return true;
    }

    const tabs = [
        {
            nombre: "CREACIÓN Y EDICIÓN",
            descripcion: "Creación y edición de turnos y actividades",
            icono: "fas fa-plus",
            componente: (
                <Row>
                    <PasoTutorial
                        titulo="1. EDICIÓN DE TURNOS"
                        imagen="tutorial-step-1.png"
                        gif="tutorial-step-1.gif"
                    >
                        Para editar un turno, tendrás que dar{" "}
                        <strong>CLICK IZQUIERDO</strong> {' '}
                        sobre el recuadro que contiene el turno que deseas
                        editar. Inmediatamente aparecerá una ventana emergente
                        desde la cual podrás escoger el nuevo turno
                    </PasoTutorial>

                    <PasoTutorial
                        titulo="2. ASIGNACIÓN DE ACTIVIDADES"
                        imagen="tutorial-step-2.png"
                        gif="tutorial-step-2.gif"
                    >
                        Para agregar o editar una actividad, tendrás que dar
                        <strong> CLICK DERECHO</strong> sobre el recuadro que
                        contiene el turno que deseas editar. Inmediatamente
                        aparecerá una ventana emergente desde la cual podrás
                        escoger el nuevo turno
                    </PasoTutorial>
                </Row>
            ),
        },
        {
            nombre: "EDICIÓN MÚLTIPLE",
            descripcion: "Creación y edición múltiple de turnos y actividades",
            icono: "fas fa-plus",
            componente: (
                <Row>
                    <PasoTutorial
                        titulo="3. EDICIÓN MÚLTIPLE DE TURNOS"
                        imagen="tutorial-step-3.png"
                        gif="tutorial-step-3.gif"
                    >
                        Para editar varios turnos al mismo tiempo, tendrás que
                        presional la tecla CTRL y dar{" "}
                        <strong>CLICK IZQUIERDO</strong> {' '}
                        sobre los recuadros que desees seleccionar. Cuando hayas
                        terminado de seleccionar los turnos, puedes dejar de
                        presionar <strong>CTRL </strong> y dar{" "}
                        <strong>CLICK IZQUIERDO</strong> sobre cualquiera de los
                        turnos seleccionados para abrir el recuadro de edición
                        de turnos
                    </PasoTutorial>

                    <PasoTutorial
                        titulo="4. ASIGNACIÓN Y EDICIÓN MÚLTIPLE DE ACTIVIDADES"
                        imagen="tutorial-step-4.png"
                        gif="tutorial-step-4.gif"
                    >
                        Para editar varias actividades al mismo tiempo, tendrás
                        que presional la tecla <strong>CTRL</strong>y dar{" "}
                        <strong>CLICK IZQUIERDO</strong> sobre los recuadros que
                        desees seleccionar. Cuando hayas terminado de
                        seleccionar los turnos, puedes dejar de presionar{" "}
                        <strong>CTRL</strong> y dar{" "}
                        <strong>CLICK DERECHO</strong> sobre cualquiera de los
                        turnos seleccionados para abrir el recuadro de edición
                        de actividades
                    </PasoTutorial>
                </Row>
            ),
        },
        {
            nombre: "INTERCAMBIO E IMPRESIÓN DE TURNOS",
            descripcion: "Intercambio de 2 turnos e imprimir imagen del cuadro de turnos",
            icono: "fas fa-plus",
            componente: (
                <Row>
                    <PasoTutorial
                        titulo="5. INTERCAMBIO DE TURNOS"
                        imagen="tutorial-step-5.png"
                        gif="tutorial-step-5.gif"
                    >
                        Un intercambio de turnos hace referencia al hecho de que un <strong>TURNO A</strong> toma el lugar de un
                        <strong> TURNO B</strong>, y el <strong>TURNO B</strong> toma el lugar que antes ocupaba el <strong>TURNO A</strong>.
                        Para realizar este intercambio solo tendrás que arrastar un turno sobre otro mientras mantienes presionada la tecla <strong>CTRL</strong>
                    </PasoTutorial>

                    <PasoTutorial
                        titulo="6. IMPRIMIR CUADRO DE TURNO"
                        imagen="tutorial-step-6.png"
                        gif="tutorial-step-6.gif"
                    >
                        Para imprimir el cuadro de turnos en una imagen, solo tendrás que presionar el botón azul
                        que se encuentra en la parte superior de la pantalla, debes tener en cuenta que en la imágen
                        no se verán las columnas que muestran el acumulado de horas semanales y mensuales, al igual que el
                        acumulado de turnos por cada día
                    </PasoTutorial>
                </Row>
            ),
        },
    ];

    return (
        <Modal
            size="xl"
            centered={true}
            id="modalTutorial"
            isOpen={modalState.show}
            title="Instrucciones de uso"
        >
            <ModalHeader className="bg-secondary text-white text-bold text-center">
                <h4>!ÉCHALE UN VISTAZO A LAS NUEVAS CARACTERÍSTICAS QUE TENEMOS PARA TI EN LOS CUADROS DE TURNOS!</h4>
            </ModalHeader>
            <ModalBody>
                <Wizard tabs={tabs} onNextTab={onNextTab} ocultarGuardar={true} />
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    key="close"
                    onClick={() => modalState.close()}
                >
                    <i className="fas fa-times mr-2"></i>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

const PasoTutorial = ({ titulo, imagen, gif, children }) => {
    const [verGif, setVerGif] = useState(false);

    const toggleVerGif = () => {
        setVerGif(!verGif);
    };

    return (
        <Col lg={6} style={{border: '3px solid #dde6e9'}} className="p-3 mb-3">
            <h6>{titulo}</h6>
            <p>{children}</p>
            <div className="d-flex justify-content-center">
                <Button
                    onClick={toggleVerGif}
                    color={verGif ? "secondary" : "primary"}
                >
                    {verGif ? "Ver Imagen" : "Ver En Uso"}
                </Button>
            </div>
            <figure className="d-flex justify-content-center pt-3">
                <img
                    src={`img/tutorial/${verGif ? gif : imagen}`}
                    height={400}
                />
            </figure>
        </Col>
    );
};

ModalTutorial.propTypes = {
    modalState: PropTypes.object,
};

PasoTutorial.propTypes = {
    titulo: PropTypes.string,
    imagen: PropTypes.string,
    gif: PropTypes.string,
    children: PropTypes.string,
};

export default ModalTutorial;
